// calendario-api.js — amm-v3 (A3, ondata 30): parte PURA della vista
// "Calendario scadenze" (pagina 'calendario' — la griglia mensile delle
// amm_scadenze, spike o27 §1.2), testabile sotto node (contract test
// server/src/lib/amm-v3-calendario.test.js).
//
// PRINCIPI (rito A1/A2/proc-v3):
//  - TESTI e COSTANTI VERBATIM dal v1 (admin-module.js, renderCalendario
//    r.1517-1577 + MESI_L/DOW r.663-664): pinnati dal contract test.
//  - La MATEMATICA della griglia vive nel core condiviso del design system
//    (client/src/ui/month-grid-core.js — replica testata di r.1519-1545);
//    qui solo la composizione della vista.
//  - STATO CONDIVISO col v1 (parità di persistenza): il mese corrente vive
//    su AMM.cal (lazy-init identico a r.1519) e il filtro 'Solo scadute' su
//    AMM.filterScadute (A5-043: UNO stato nel modulo, condiviso col
//    Cruscotto) — flip di flag senza perdere posizione/filtri.
//  - DELEGHE alle primitive v1: openEditor (modale scadenza), apriGiornoPopover
//    ('+N altre'), urgency (colori chip), isScaduta (filtro), isoToday.
//    ZERO bypass di render da censire: i modali ridipingono via
//    renderPage(currentPage) (r.7858/7888) — NIENTE interceptor (pinnato).
//  - MAI 'nav:badge' o canali nuovi da client/src/amm-v3/** (asserito dai test).

import { apiPathFn } from './api.js';
import { calMeta } from '../ui/month-grid-core.js';

// ---- metodi di window.AMM che il v3 DELEGA (guardie: senza uno solo di
// questi la vista sarebbe monca ⇒ install inerte, mondo v1 intatto) ----
export const AC_DELEGATED_METHODS = [
  'renderPage',        // il seam stesso (wrap) + refresh post-azione
  'renderCalendario',  // la vista v1 wrappata (drift guard: rename ⇒ rosso)
  'openEditor',        // modale scadenza (click evento, + Scadenza) — resta v1
  'apriGiornoPopover', // popover '+N altre' (A3-054) — resta v1
  'urgency',           // {pill:[bg,fg,label]} per chip (unica fonte: v1)
  'isScaduta',         // filtro 'Solo scadute' (stessa condizione del pill)
  'isoToday',          // il 'today' della griglia (unica fonte: v1)
];

// ---- funzioni di window.api.amm usate dal v3 (stessa API del v1) ----
export const AC_API_PATHS = [
  'scadenze.list', // GET /scadenze?da=&a= — la finestra delle 42 celle (r.1526)
];

// ---- TESTI VERBATIM dal v1 (pinnati dal contract test sul sorgente) ----
export const AC_TEXTS = {
  title: 'Calendario scadenze',
  nuovaScadenza: '+ Scadenza',
  oggi: 'Oggi',
  soloScadute: 'Solo scadute',
  moreSuffix: ' altre', // r.1542: '+' + n + ' altre'
};

// mesi lunghi e giorni settimana — VERBATIM v1 r.663-664
export const MESI_L = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
export const DOW = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];

// stile del chip 'Solo scadute' attivo — VERBATIM v1 r.1554
export const AC_CHIP_ATTIVO = { background: '#ffe4e6', color: '#9f1239', borderColor: '#fecdd3' };

// ---- STATO condiviso col v1 ----

// il mese della griglia vive SU AMM (replica del lazy-init r.1519): il v3 lo
// legge e lo scrive lì ⇒ il flip di flag (v3→v1 o viceversa) conserva il mese
export function calStato(A) {
  if (!A.cal) {
    const n = new Date();
    A.cal = { y: n.getFullYear(), m: n.getMonth() };
  }
  return A.cal;
}

// ---- FORMULE v1 replicate (pure) ----

// filtro 'Solo scadute' (r.1530) — isScaduta arriva per parametro (a runtime:
// delega ad AMM.isScaduta, stessa condizione del pill)
export function filtraScadute(rows, soloScadute, isScaduta) {
  const lista = rows || [];
  return soloScadute ? lista.filter((s) => isScaduta(s)) : lista;
}

// chip evento della cella (r.1538-1540): titolo + colori urgenza dal v1
export function chipScadenza(A, s) {
  const u = A.urgency(s);
  return { label: s.titolo, bg: u.pill[0], fg: u.pill[1] };
}

// link '+N altre' (r.1542)
export function moreLabel(n) {
  return '+' + n + AC_TEXTS.moreSuffix;
}

// ---- LETTURA dati: stessa finestra del v1 (r.1524-1526) ----
export async function readCalendario(win, y, m) {
  const meta = calMeta(y, m);
  const rows = await apiPathFn(win, 'scadenze.list').call(null, { da: meta.da, a: meta.a });
  return rows || [];
}

// ---- DELEGHE alle primitive v1 (modali/popover/refresh) ----
export function apriEditor(win, rec) { win.AMM.openEditor(rec); }
export function apriNuova(win) { win.AMM.openEditor({}); }
export function apriPopoverGiorno(win, evs, anchorEl) { win.AMM.apriGiornoPopover(evs, anchorEl); }
